import React from 'react';
import './Darshan.css';
import { useLanguage } from '../context/LanguageContext';

const Darshan = () => {
    const { t } = useLanguage();

    return (
        <div className="darshan-page">
            {/* Sticky Timing Banner */}
            <div className="sticky-timing-banner">
                <p className="timing-text-marathi">
                    दर्शन वेळ: सकाळी: ५:०० - ११:०० | संध्याकाळी: ४:०० - ९:००
                </p>
            </div>

            {/* Main Content Area */}
            <div className="deity-idol-container">
                <img 
                    src="/Assets/darshan_full.png" 
                    alt="Shri Nath Mahaskoba Maharaj" 
                    className="deity-idol-img"
                />
                
                {/* Visual Enhancements */}
                <div className="sacred-overlay"></div>
                
                <div className="puja-setup-overlay">
                    {/* These could be subtle animated elements or just part of the image */}
                    <div className="glow-effect"></div>
                </div>
            </div>
        </div>
    );
};

export default Darshan;
